import { handleAdminQuantityDefinitionCategoryUpdated } from "./admin";
import { handleUserQuantityDefinitionCategoryUpdated } from "./user";

export function updateQuantityDefintionCategory(state, patch) {

    console.log('handleQuantityDefintionCategoryUpdated: ', patch)
    const { visibility, payload } = patch;
    if (patch.visibility === "admin") {
        return handleAdminQuantityDefinitionCategoryUpdated(state, payload);
    }

    return handleUserQuantityDefinitionCategoryUpdated(state, payload);
}